<main>
  <!-- Hero Section -->
  <section
    class="bg-[url('/assets/images/Model3_54.webp')] bg-cover bg-center bg-blend-multiply bg-black/50 min-h-[40vh] flex flex-col justify-center items-center text-white px-3 md:px-5 2xl:px-28 3xl:px-52"
  >
    <div
      class="container flex flex-col justify-center items-center text-center"
    >
      <h1 class="text-3xl lg:text-5xl font-extrabold text-center mb-3">
        Privacy Policy
      </h1>
      <p class="text-white font-semibold text-center text-lg lg:text-xl">
        Committed to Protecting Your Data with Transparency and Trust
      </p>
    </div>
  </section>

  <section class="px-3 md:px-5 2xl:px-28 3xl:px-52 py-10 xl:py-16">
    <div
      class="container mx-auto lg:flex-row items-center w-full py-[1.6rem]"
    >
      <!-- USER AGREEMENT -->
      <div class="lg:basis-[50%] mb-5">
        <h2 class="text-3xl lg:text-4xl font-bold mb-3">
          PRIVACY POLICY FOR ONLY USED TESLA
        </h2>
        <p class="text-xl mb-6">
          <span class="font-bold">Effective Date:</span> March 28, 2025
        </p>
        <h2 class="text-2xl lg:text-2xl font-bold mb-3">Introduction</h2>
        <p>
          Only Used Tesla ("we," "us," or "our") respects the privacy of
          visitors and users of our website ("site"). This Privacy Policy
          clearly outlines how we collect, use, store, and share information
          obtained from users of our site,
          <a
            class="font-bold underline text-[blue]"
            href="https://www.onlyusedtesla.com"
            >onlyUsedTesla.com</a
          >. By using our site, you acknowledge and consent to the terms
          described herein.
        </p>
      </div>

      <div class="lg:basis-[50%] mb-5">
        <h2 class="text-2xl lg:text-3xl font-bold mb-3">
          Information We Collect
        </h2>
        <ol class="list-decimal pl-5 list-inside">
          <li>Personal Information:</li>
          <ul class="list-disc pl-5 list-inside">
            <li>
              Name, email address, telephone number, and address (if voluntarily
              provided).
            </li>
            <li>
              Information provided through forms, user accounts, or
              communications.
            </li>
          </ul>
          <li>Non-Personal Information:</li>
          <ul class="list-disc pl-5 list-inside">
            <li>
              Browsing activity, IP address, browser type, device type,
              date/time stamps, pages visited, and interactions on our website.
            </li>
          </ul>
        </ol>
      </div>

      <div class="lg:basis-[50%] mb-5">
        <h2 class="text-2xl lg:text-3xl font-bold mb-3">
          Use of Tracking Technologies
        </h2>
        <p>
          Our website utilizes standard tracking technologies, including
          cookies, pixels (such as Meta Pixel), and analytics services (such as
          Google Analytics). These technologies help us:
        </p>
        <ol class="list-decimal pl-5 list-inside">
          <li>Analyze website traffic and user interactions.</li>
          <li>Optimize user experience and improve our services.</li>
          <li>Deliver targeted advertising and promotional materials.</li>
        </ol>
      </div>

      <div class="lg:basis-[50%] mb-5">
        <h2 class="text-2xl lg:text-3xl font-bold mb-3">
          Consent and User Control
        </h2>
        <p>
          Upon your first visit to our website, you are presented with a clear
          and conspicuous cookie consent banner. By clicking “Accept,” you
          explicitly consent to the use of these tracking technologies. You can
          manage or withdraw your consent at any time through your browser
          settings or our consent management tools provided on the site.
        </p>
      </div>

      <div class="lg:basis-[50%] mb-5">
        <h2 class="text-2xl lg:text-3xl font-bold mb-3">
          Sharing Information with Third Parties
        </h2>
        <p>
          We may share non-personal and certain personal information with
          third-party vendors (such as Meta/Facebook and Google) who provide
          analytics and advertising services. These third parties may collect
          data about your interaction with our site, which they may use to
          enhance their services and provide targeted advertising.
        </p>
      </div>

      <div class="lg:basis-[50%] mb-5">
        <h2 class="text-2xl lg:text-3xl font-bold mb-3">Data Security</h2>
        <p>
          We implement commercially reasonable security measures to protect your
          personal data against unauthorized access, alteration, disclosure, or
          destruction. However, no method of internet transmission or storage is
          completely secure, and we cannot guarantee absolute security.
        </p>
      </div>

      <div class="lg:basis-[50%] mb-5">
        <h2 class="text-2xl lg:text-3xl font-bold mb-3">
          California Privacy Rights (CCPA & CIPA)
        </h2>
        <p>
          California residents have the right to request information about
          personal data we have collected and to request deletion of that data.
          If you are a California resident, you may exercise these rights by
          contacting us via email at
          <a
            class="font-bold underline text-[blue]"
            href="mailto:contact@onlyusedtesla.com"
            >contact&commat;OnlyUsedTesla.com.</a
          >.
        </p>
      </div>

      <div class="lg:basis-[50%] mb-5">
        <h2 class="text-2xl lg:text-3xl font-bold mb-3">
          Changes to This Policy
        </h2>
        <p>
          We reserve the right to update or modify this Privacy Policy at any
          time. The effective date at the top of this page will indicate when
          the latest updates have been made. We encourage you to periodically
          review this Privacy Policy to stay informed about how we protect your
          information.
        </p>
      </div>

      <div class="lg:basis-[50%] mb-5">
        <h2 class="text-2xl lg:text-3xl font-bold mb-3">
          Dispute Resolution and Arbitration
        </h2>
        <p>
          Any disputes arising out of this Privacy Policy, including those
          involving privacy-related claims or the use of our services, shall be
          governed by the laws of the State of New York without regard to
          conflict of law principles. Arbitration will be conducted exclusively
          in Suffolk County, New York, under the rules of the American
          Arbitration Association (AAA). You expressly consent to arbitration in
          New York and waive any right to arbitration or litigation elsewhere.
        </p>
      </div>

      <div class="lg:basis-[50%] mb-5">
        <h2 class="text-2xl lg:text-3xl font-bold mb-3">Contact Us</h2>
        <p>
          If you have any questions or concerns about this Privacy Policy or our
          practices, please contact us at:
        </p>
        <h3 class="text-xl font-bold mb-2">Only Used Tesla</h3>
        <p>
          Email:
          <a
            class="font-bold underline text-[blue]"
            href="mailto:contact@onlyusedtesla.com"
            >contact&commat;OnlyUsedTesla.com</a
          >
        </p>
      </div>
      <p>
        By continuing to use our website, you acknowledge and agree to this
        Privacy Policy and our terms of service.
      </p>
    </div>
  </section>
</main>
